// import React, { useState, useEffect, useCallback } from "react";

// import {
//   Box,
//   Card,
//   Typography,
//   IconButton,
//   Modal,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   Badge,
//   Drawer,
//   SwipeableDrawer,
//   Popover,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Paper,
//   Avatar,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Chip,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { getComapnyCalender } from "../../../../Redux/Reducers/JobReducer";
// import {
//   LocalizationProvider,
//   DateCalendar,
//   PickersDay,
// } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
// import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
// import dayjs from "dayjs";
// import { styled } from "@mui/material/styles";
// import { grey } from "@mui/material/colors";
// import { Global } from "@emotion/react";
// import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
// import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
// import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
// import ScheduleEvent from "../SheduleEvent";
// import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
// import EditRoundedIcon from "@mui/icons-material/EditRounded";
// import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
// import "../../../../Assets/css/Jobs/ScheduleEvent.css";
// import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
// import {
//   deleteProfessionalEvents,
//   getCompanyEvents,
//   getProfessionalEvents,
// } from "../../../../Redux/Reducers/calendarReducer";

// const timeZones = Intl.supportedValuesOf("timeZone");

// const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       aria-labelledby="alert-dialog-title"
//       aria-describedby="alert-dialog-description"
//     >
//       <DialogTitle id="alert-dialog-title">{"Delete Event"}</DialogTitle>
//       <DialogContent>
//         <DialogContentText id="alert-dialog-description">
//           Are you sure you want to delete this event? This action cannot be
//           undone.
//         </DialogContentText>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Cancel
//         </Button>
//         <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
//           Delete
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// const CompanyCalender = ({ initialView = "month", companyName }) => {
//   const dispatch = useDispatch();
//   const companyCalender =
//     useSelector((state) => state?.calender?.companyEventsData) || [];
//   const userEmail =
//     useSelector(
//       (state) => state?.ProfileArray?.professionaProfile?.professional_email
//     ) || "";

//   const [date, setDate] = useState(dayjs());
//   const [view, setView] = useState(initialView);
//   const [selectedDateEvents, setSelectedDateEvents] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [dayDrawerOpen, setDayDrawerOpen] = useState(false);
//   const [scheduleDrawerOpen, setScheduleDrawerOpen] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [selectedEventId, setSelectedEventId] = useState(null);

//   // Helper function to check if a date is in the past
//   const isDateInPast = (dateToCheck) => {
//     return dayjs(dateToCheck).isBefore(dayjs(), 'day');
//   };

//   // Helper function to check if a date/time is in the past
//   const isDateTimeInPast = (dateTime) => {
//     return dayjs(dateTime).isBefore(dayjs());
//   };

//   // Filter only interview events
//   const interviewEvents = companyCalender.filter(
//     (event) => 
//       event.eventType === "Interview" || 
//       event.eventType === "Others" || 
//       event.interviewType
//   );

//   console.log("interviewEvents123", interviewEvents, companyCalender);

//   useEffect(() => {
//     if (view === "month" && companyName) {
//       const firstDayOfMonth = date.startOf("month");
//       const lastDayOfMonth = date.endOf("month"); 

//       dispatch(
//         getCompanyEvents({
//           companyName: companyName,
//           type: "all",
//           timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
//           timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
//         })
//       );
//     }
//   }, [date, view, companyName, dispatch]);

//   // Check if current user is the creator of the event
//   const isEventCreator = (event) => {
//     return event.createdBy === userEmail;
//   };

//   const handleDateClick = (newValue) => {
//     setDate(newValue);
//     const selectedDayStr = newValue.format("YYYY-MM-DD");

//     // Filter only interview events for the selected day
//     const dayInterviews = interviewEvents?.filter(
//       (event) => dayjs(event.startTime).format("YYYY-MM-DD") === selectedDayStr
//     );

//     setSelectedDateEvents(dayInterviews);
//     setDayDrawerOpen(true);
//   };

//   const handleAddNewEvent = useCallback(() => {
//     setEditMode(false);
//     setSelectedEvent(null);
//     setScheduleDrawerOpen(true);
//   }, []);

//   const handleEditEvent = (event) => {
//     setEditMode(true);
//     setSelectedEvent(event);
//     setScheduleDrawerOpen(true);
//   };

//   const handleDeleteEvent = (eventId) => {
//     setSelectedEventId(eventId);
//     setDeleteDialogOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       await dispatch(deleteProfessionalEvents(selectedEventId));
//       setDeleteDialogOpen(false);

//       // Refresh calendar data
//       if (companyName) {
//         const firstDayOfMonth = date.startOf("month");
//         const lastDayOfMonth = date.endOf("month");

//         dispatch(
//           getCompanyEvents({
//             companyName: companyName,
//             type: "all",
//             timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
//             timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
//           })
//         );
//       }
//     } catch (error) {
//       console.error("Failed to delete event:", error);
//     }
//   };

//   const getEventColor = (event) => {
//     // Check if event object is provided
//     if (!event) {
//       return "#e3f2fd"; // Default light blue for calendar days with any events
//     }

//     if (event.eventType === "Others") {
//       return "#e0f7fa"; // Light cyan for "Others" event type
//     }

//     return "#e3f2fd"; // Light blue for interviews
//   };

//   // Function to determine calendar day color based on events
//   const getDayBackgroundColor = (dayEvents) => {
//     if (!dayEvents || dayEvents.length === 0) {
//       return 'transparent';
//     }

//     // Check if any event is "Others" type
//     const hasOtherEvents = dayEvents.some(event => event.eventType === "Others");
//     // Check if any event is "Interview" type
//     const hasInterviewEvents = dayEvents.some(event => 
//       event.eventType === "Interview" || event.interviewType
//     );

//     if (hasOtherEvents && hasInterviewEvents) {
//       // Both types present - create gradient
//       return 'linear-gradient(135deg, #e3f2fd 50%, #e0f7fa 50%)';
//     } else if (hasOtherEvents) {
//       // Only "Others" events
//       return '#e0f7fa';
//     } else {
//       // Only interview events or mixed with interviews
//       return '#e3f2fd';
//     }
//   };

//   // Function to determine day border color
//   const getDayBorderColor = (dayEvents) => {
//     if (!dayEvents || dayEvents.length === 0) {
//       return 'transparent';
//     }

//     const hasOtherEvents = dayEvents.some(event => event.eventType === "Others");
//     const hasInterviewEvents = dayEvents.some(event => 
//       event.eventType === "Interview" || event.interviewType
//     );

//     if (hasOtherEvents && hasInterviewEvents) {
//       return '#1e88e5'; // Darker blue for mixed days
//     } else if (hasOtherEvents) {
//       return '#00bcd4'; // Cyan border for "Others"
//     } else {
//       return '#2196f3'; // Blue border for interviews
//     }
//   };

//   // Function to handle location click - opens Google Maps
//   const handleLocationClick = (location) => {
//     if (location) {
//       const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//         location
//       )}`;
//       window.open(mapsUrl, "_blank");
//     }
//   };

//   // Function to handle meet link click - opens in new tab
//   const handleMeetLinkClick = (meetLink) => {
//     if (meetLink) {
//       window.open(meetLink, "_blank");
//     }
//   };

//   const DayViewTimeGrid = ({ events, date }) => {
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

//     // Check if the date is today or future
//     const isTodayOrFuture = !isDateInPast(date);

//     const handleEventClick = (event) => {
//       // Only open drawer if it's not already open or if a different event is clicked
//       if (!drawerOpen || selectedTimeSlot?.id !== event.id) {
//         setSelectedTimeSlot(event);
//         setSelectedEvent(event);
//         setDrawerOpen(true);
//       }
//     };

//     const handleCloseDrawer = () => {
//       setDrawerOpen(false);
//       setSelectedTimeSlot(null);
//       setSelectedEvent(null);
//     };

//     const getTimeSlots = () => {
//       const slots = [];
//       for (let i = 0; i < 24; i++) {
//         slots.push(dayjs().hour(i).minute(0));
//       }
//       return slots;
//     };

//     const timeSlots = getTimeSlots();

//     return (
//       <Box sx={{ height: "100%", overflow: "auto", backgroundColor: "#fff",  }}>
//         {/* Today header */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             p: 2,
//             borderBottom: "1px solid #eee",
//           }}
//         >
//           <Button variant="outlined" startIcon={<TodayRoundedIcon />}>
//             {date.format("MMMM D, YYYY")}
//           </Button>
//           {/* Only show add button for today or future dates */}
//           {isTodayOrFuture && (
//             <IconButton onClick={handleAddNewEvent}>
//               <AddCircleOutlineRoundedIcon color="primary" />
//             </IconButton>
//           )}
//         </Box>

//         {/* Time slots grid */}
//         {timeSlots.map((slot) => {
//           const slotEvents =
//             events?.filter(
//               (event) => dayjs(event.startTime).hour() === slot.hour()
//             ) || [];

//           return (
//             <Box
//               key={slot.format("HH:mm")}
//               sx={{
//                 display: "flex",
//                 borderBottom: "1px solid #eee",
//                 minHeight: "60px",
//                 position: "relative",
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "60px",
//                   p: 1,
//                   color: "text.secondary",
//                   fontSize: "12px",
//                   textAlign: "right",
//                 }}
//               >
//                 {slot.format("h A")}
//               </Box>
//               <Box
//                 sx={{
//                   flex: 1,
//                   position: "relative",
//                   borderLeft: "1px solid #eee",
//                 }}
//               >
//                 {slotEvents.map((event, index) => {
//                   const startTime = dayjs(event.startTime);
//                   const endTime = dayjs(event.endTime);

//                   // Calculate position based on exact minutes
//                   const startMinutes =
//                     startTime.hour() * 60 + startTime.minute();
//                   const endMinutes = endTime.hour() * 60 + endTime.minute();
//                   const duration = endMinutes - startMinutes;

//                   // Calculate position as percentage of day (1440 minutes)
//                   const topPosition = (startMinutes / 1440) * 100;
//                   const height = (duration / 1440) * 100;

//                   return (
//                     <Card
//                       key={`${event.id}-${index}`}
//                       onClick={() => handleEventClick(event)}
//                       sx={{
//                         position: "absolute",
//                         left: "2px",
//                         right: "2px",
//                         top: `${topPosition}%`,
//                         height: `${height}%`,
//                         minHeight: "48px", // Reduced minimum height
//                         p: 0.5, // Reduced padding
//                         backgroundColor: getEventColor(event),
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 2,
//                           zIndex: 2,
//                           transform: "scale(1.02)",
//                           transition: "all 0.2s ease",
//                         },
//                         zIndex: 1,
//                         overflow: "hidden",
//                         border: event.eventType === "Others" 
//                           ? "1px solid #80deea" 
//                           : "1px solid #90caf9",
//                       }}
//                     >
//                       <Box sx={{ width: "100%", height: "100%" }}>
//                         <Typography
//                           variant="caption"
//                           display="block"
//                           noWrap
//                           sx={{ fontSize: "10px", fontWeight: "bold" }}
//                         >
//                           {event.title}
//                         </Typography>
//                         <Box
//                           sx={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                           }}
//                         >
//                           <Typography
//                             variant="body2"
//                             color="text.secondary"
//                             sx={{ fontSize: "8px" }}
//                           >
//                             {startTime.format("h:mm A")} -{" "}
//                             {endTime.format("h:mm A")}
//                           </Typography>
//                           <Typography
//                             color="text.secondary"
//                             sx={{ fontSize: "8px" }}
//                             noWrap
//                           >
//                             {event?.interviewType || event?.eventType || "Interview"}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Card>
//                   );
//                 })}
//               </Box>
//             </Box>
//           );
//         })}

//         {/* Event Details Drawer */}
//         <SwipeableDrawer
//           anchor="right"
//           open={drawerOpen}
//           onClose={handleCloseDrawer}
//           PaperProps={{
//             sx: {
//               width: "400px",
//               maxWidth: "90vw",
//             },
//           }}
//         >
//           <Box sx={{ p: 3, height: "100%", overflow: "auto" }}>
//             {selectedTimeSlot && (
//               <>
//                 {/* Header */}
//                 <Box
//                   sx={{
//                     mb: 3,
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     pb: 2,
//                     borderBottom: "1px solid #eee",
//                   }}
//                 >
//                   <Box>
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: 600, color: "#1a1a1a" }}
//                     >
//                       {selectedTimeSlot?.title}
//                     </Typography>
//                     <Typography variant="subtitle1" sx={{ color: "#666" }}>
//                       {selectedTimeSlot?.eventType === "Others" 
//                         ? "Other Event" 
//                         : "Interview"}
//                     </Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     {/* Show edit/delete only if user is the creator */}
//                     {isEventCreator(selectedTimeSlot) && (
//                       <>
//                         <IconButton
//                           onClick={() => handleEditEvent(selectedTimeSlot)}
//                           color="primary"
//                           size="small"
//                         >
//                           <EditRoundedIcon />
//                         </IconButton>
//                         <IconButton
//                           onClick={() =>
//                             handleDeleteEvent(selectedTimeSlot?.id)
//                           }
//                           color="primary"
//                           size="small"
//                         >
//                           <DeleteRoundedIcon />
//                         </IconButton>
//                       </>
//                     )}
//                     <IconButton onClick={handleCloseDrawer}>
//                       <CloseIcon />
//                     </IconButton>
//                   </Box>
//                 </Box>

//                 {/* Time & Duration */}
//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     backgroundColor: "#f8f9fa",
//                     borderRadius: 2,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <Box sx={{ mr: 2 }}>
//                       <TodayRoundedIcon color="primary" />
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Time
//                       </Typography>
//                       <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                         {dayjs(selectedTimeSlot?.startTime).format("hh:mm A")} -{" "}
//                         {dayjs(selectedTimeSlot?.endTime).format("hh:mm A")}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Box sx={{ display: "flex", alignItems: "center" }}>
//                     <Box sx={{ mr: 2 }}>
//                       <ScheduleRoundedIcon color="primary" />
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Duration
//                       </Typography>
//                       <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                         {selectedTimeSlot?.duration} minutes
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Event Type */}
//                 {selectedTimeSlot?.eventType && (
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="h6" sx={{ mb: 1 }}>
//                       Event Type
//                     </Typography>
//                     <Paper 
//                       sx={{ 
//                         p: 2, 
//                         backgroundColor: selectedTimeSlot?.eventType === "Others" 
//                           ? "#e0f7fa" 
//                           : "#f8f9fa" 
//                       }}
//                     >
//                       <Typography variant="body1">
//                         {selectedTimeSlot?.eventType}
//                       </Typography>
//                     </Paper>
//                   </Box>
//                 )}

//                 {/* Interview Type (only for interviews) */}
//                 {selectedTimeSlot?.eventType === "Interview" && selectedTimeSlot?.interviewType && (
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="h6" sx={{ mb: 1 }}>
//                       Interview Type
//                     </Typography>
//                     <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
//                       <Typography variant="body1">
//                         {selectedTimeSlot?.interviewType}
//                       </Typography>
//                     </Paper>
//                   </Box>
//                 )}

//                 {/* Location for F2F Interviews */}
//                 {selectedTimeSlot?.interviewType === "F2F" &&
//                   selectedTimeSlot?.location && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography variant="h6" sx={{ mb: 1 }}>
//                         Location
//                       </Typography>
//                       <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
//                         <Button
//                           variant="text"
//                           onClick={() =>
//                             handleLocationClick(selectedTimeSlot?.location)
//                           }
//                           startIcon={<LocationOnRoundedIcon />}
//                           sx={{ textTransform: "none" }}
//                         >
//                           {selectedTimeSlot?.location}
//                         </Button>
//                       </Paper>
//                     </Box>
//                   )}

//                 {/* Meet Link for Remote Interviews */}
//                 {selectedTimeSlot?.interviewType === "Remote" &&
//                   selectedTimeSlot?.meetLink && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography variant="h6" sx={{ mb: 1 }}>
//                         Meeting Link
//                       </Typography>
//                       <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
//                         <Button
//                           variant="text"
//                           onClick={() =>
//                             handleMeetLinkClick(selectedTimeSlot?.meetLink)
//                           }
//                           startIcon={<VideocamRoundedIcon />}
//                           sx={{ textTransform: "none" }}
//                         >
//                           Join Virtual Meeting
//                         </Button>
//                       </Paper>
//                     </Box>
//                   )}

//                 {/* Fallback for meet_link field (if interviewType is not set but meet_link exists) */}
//                 {!selectedTimeSlot?.interviewType &&
//                   selectedTimeSlot?.meet_link && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography variant="h6" sx={{ mb: 1 }}>
//                         Meeting Link
//                       </Typography>
//                       <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
//                         <Button
//                           variant="text"
//                           onClick={() =>
//                             handleMeetLinkClick(selectedTimeSlot?.meet_link)
//                           }
//                           startIcon={<VideocamRoundedIcon />}
//                           sx={{ textTransform: "none" }}
//                         >
//                           Join Virtual Meeting
//                         </Button>
//                       </Paper>
//                     </Box>
//                   )}

//                 {/* Description */}
//                 {selectedTimeSlot?.description && (
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="h6" sx={{ mb: 1 }}>
//                       Description
//                     </Typography>
//                     <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
//                       <Typography variant="body1">
//                         {selectedTimeSlot?.description}
//                       </Typography>
//                     </Paper>
//                   </Box>
//                 )}

//                 {/* Attendees */}
//                 {selectedTimeSlot?.attendees &&
//                   selectedTimeSlot?.attendees?.length > 0 && (
//                     <Box sx={{ mb: 3 }}>
//                       <Typography variant="h6" sx={{ mb: 2 }}>
//                         Attendees
//                       </Typography>
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                         {selectedTimeSlot?.attendees?.map((attendee, index) => (
//                           <Box
//                             key={index}
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               p: 1,
//                               backgroundColor: "#f8f9fa",
//                               borderRadius: 2,
//                             }}
//                           >
//                             <Avatar
//                               src={attendee?.profile_pic}
//                               sx={{ width: 32, height: 32, mr: 1 }}
//                             />
//                             <Box>
//                               <Typography
//                                 variant="body2"
//                                 sx={{ fontWeight: 500 }}
//                               >
//                                 {attendee?.name}
//                               </Typography>
//                               <Typography
//                                 variant="caption"
//                                 color="text.secondary"
//                               >
//                                 {attendee?.email}
//                               </Typography>
//                             </Box>
//                           </Box>
//                         ))}
//                       </Box>
//                     </Box>
//                   )}

//                 {/* Created By Information */}
//                 {selectedTimeSlot?.createdBy && (
//                   <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #eee" }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Created by: {selectedTimeSlot?.createdBy}
//                     </Typography>
//                     {isEventCreator(selectedTimeSlot) && (
//                       <Typography variant="caption" color="primary">
//                         (You created this event)
//                       </Typography>
//                     )}
//                   </Box>
//                 )}
//               </>
//             )}
//           </Box>
//         </SwipeableDrawer>
//       </Box>
//     );
//   };

//   const handleCloseDayDrawer = () => {
//     setDayDrawerOpen(false);
//     setSelectedDateEvents([]);

//     // Refresh calendar data when closing day view
//     if (companyName) {
//       const firstDayOfMonth = date.startOf("month");
//       const lastDayOfMonth = date.endOf("month");

//       dispatch(
//         getCompanyEvents({
//           companyName: companyName,
//           type: "all",
//           timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
//           timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
//         })
//       );
//     }
//   };

//   const getUniqueEvents = (events) => {
//     const map = new Map();
//     events.forEach((event) => {
//       map.set(event.id, event); // Keeps last unique event
//     });
//     return Array.from(map.values());
//   };

//   const todaysInterviews = getUniqueEvents(
//     interviewEvents?.filter(
//       (event) =>
//         dayjs(event?.startTime).format("YYYY-MM-DD") ===
//         dayjs().format("YYYY-MM-DD")
//     )
//   );

//   return (
//     <Box sx={{ height: "100%", display: "flex", flexDirection: "column",  }}>
//       {/* Monthly View */}
//       <Card sx={{ p: 2, overflow: "hidden", maxWidth: "100%", margin: "auto" }}>
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DateCalendar
//             value={date}
//             onChange={handleDateClick}
//             onMonthChange={(newValue) => {
//               setDate(newValue);
//             }}
//             // REMOVED: disablePast={true} - Allow past dates to be visible and clickable
//             slots={{
//               day: (props) => {
//                 const { day, ...otherProps } = props;
//                 const dayStr = day?.format("YYYY-MM-DD");
//                 const dayInterviews = getUniqueEvents(
//                   interviewEvents?.filter(
//                     (event) =>
//                       dayjs(event?.startTime).format("YYYY-MM-DD") === dayStr
//                   )
//                 );

//                 // REMOVED: Disabling past days - keep all dates enabled
//                 return (
//                   <PickersDay
//                     {...otherProps}
//                     day={day}
//                     sx={{
//                       ...(dayInterviews?.length > 0 && {
//                         background: getDayBackgroundColor(dayInterviews),
//                         border: `1px solid ${getDayBorderColor(dayInterviews)}`,
//                         color: "#1976d2",
//                         "&:hover": {
//                           backgroundColor: dayInterviews.some(event => event.eventType === "Others")
//                             ? "#b2ebf2"
//                             : "#bbdefb",
//                           opacity: 0.9,
//                         },
//                         "&.Mui-selected": {
//                           background: getDayBackgroundColor(dayInterviews),
//                           border: `2px solid ${getDayBorderColor(dayInterviews)}`,
//                           "&:hover": {
//                             background: getDayBackgroundColor(dayInterviews),
//                           },
//                         },
//                       }),
//                     }}
//                   />
//                 );
//               },
//             }}
//           />
//         </LocalizationProvider>
//       </Card>

//       {/* Today's Interviews Section */}
//       <Box sx={{ flex: 1, overflow: "auto", px: 2, maxHeight: "50vh", }}>
//         <Typography variant="h6" sx={{ p: 1 }}>
//           Today's Events
//         </Typography>

//         {todaysInterviews?.length === 0 ? (
//           <Typography variant="body1" color="text.secondary" align="center">
//             No events scheduled for today
//           </Typography>
//         ) : (
//           todaysInterviews
//             ?.sort((a, b) => dayjs(a?.startTime).diff(dayjs(b?.startTime)))
//             ?.map((event) => (
//               <Accordion
//                 key={event?.id}
//                 sx={{
//                   mb: 1,
//                   "&:before": { display: "none" },
//                   backgroundColor: getEventColor(event),
//                   boxShadow: "none",
//                   "&:hover": {
//                     backgroundColor: event.eventType === "Others" 
//                       ? "#b2ebf2" 
//                       : "#bbdefb",
//                   },
//                   border: event.eventType === "Others" 
//                     ? "1px solid #80deea" 
//                     : "1px solid #90caf9",
//                 }}
//               >
//                 <AccordionSummary
//                   expandIcon={<ExpandMoreRoundedIcon />}
//                   sx={{
//                     "& .MuiAccordionSummary-content": {
//                       margin: "8px 0",
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       width: "100%",
//                     }}
//                   >
//                     <Box sx={{ flexGrow: 1 }}>
//                       <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
//                         {event?.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {dayjs(event?.startTime).format("h:mm A")} -{" "}
//                         {dayjs(event?.endTime).format("h:mm A")}
//                       </Typography>
//                     </Box>
//                     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                       {/* Show location icon for F2F */}
//                       {event?.interviewType === "F2F" && event?.location && (
//                         <LocationOnRoundedIcon
//                           fontSize="small"
//                           color="primary"
//                         />
//                       )}
//                       {/* Show video icon for Remote */}
//                       {event?.interviewType === "Remote" && event?.meetLink && (
//                         <VideocamRoundedIcon fontSize="small" color="primary" />
//                       )}
//                       {/* Fallback for meet_link field */}
//                       {!event?.interviewType && event?.meet_link && (
//                         <VideocamRoundedIcon fontSize="small" color="primary" />
//                       )}
//                       <Typography variant="caption" color="text.secondary">
//                         {event?.eventType === "Others" 
//                           ? "Other Event" 
//                           : event?.interviewType || "Interview"}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </AccordionSummary>

//                 <AccordionDetails>
//                   <Box
//                     sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//                   >
//                     {event?.description && (
//                       <Typography variant="body2">
//                         {event?.description}
//                       </Typography>
//                     )}

//                     {/* Event Type Display */}
//                     {event?.eventType && (
//                       <Box>
//                         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                           Event Type: {event?.eventType}
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* F2F Location */}
//                     {event?.interviewType === "F2F" && event?.location && (
//                       <Button
//                         variant="text"
//                         onClick={() => handleLocationClick(event?.location)}
//                         startIcon={<LocationOnRoundedIcon />}
//                         sx={{ alignSelf: "flex-start", textTransform: "none" }}
//                       >
//                         {event?.location}
//                       </Button>
//                     )}

//                     {/* Remote Meet Link */}
//                     {event?.interviewType === "Remote" && event?.meetLink && (
//                       <Button
//                         variant="text"
//                         onClick={() => handleMeetLinkClick(event?.meetLink)}
//                         startIcon={<VideocamRoundedIcon />}
//                         sx={{ alignSelf: "flex-start", textTransform: "none" }}
//                       >
//                         Join Meeting
//                       </Button>
//                     )}

//                     {/* Fallback for meet_link field */}
//                     {!event?.interviewType && event?.meet_link && (
//                       <Button
//                         variant="text"
//                         onClick={() => handleMeetLinkClick(event?.meet_link)}
//                         startIcon={<VideocamRoundedIcon />}
//                         sx={{ alignSelf: "flex-start", textTransform: "none" }}
//                       >
//                         Join Meeting
//                       </Button>
//                     )}

//                     {event?.attendees?.length > 0 && (
//                       <Box>
//                         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                           Attendees:
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {event?.attendees?.map((attendee, index) => (
//                             <Chip
//                               key={index}
//                               avatar={
//                                 <Avatar
//                                   src={attendee?.profile_pic}
//                                   alt={attendee?.name}
//                                 />
//                               }
//                               label={attendee?.name}
//                               size="small"
//                               variant="outlined"
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     {/* Edit/Delete buttons for creator */}
//                     {isEventCreator(event) && (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           gap: 1,
//                           justifyContent: "flex-end",
//                           mt: 1,
//                         }}
//                       >
//                         <Button
//                           size="small"
//                           startIcon={<EditRoundedIcon />}
//                           onClick={() => handleEditEvent(event)}
//                           color="primary"
//                         >
//                           Edit
//                         </Button>
//                         <Button
//                           size="small"
//                           startIcon={<DeleteRoundedIcon />}
//                           onClick={() => handleDeleteEvent(event.id)}
//                           color="error"
//                         >
//                           Delete
//                         </Button>
//                       </Box>
//                     )}
//                   </Box>
//                 </AccordionDetails>
//               </Accordion>
//             ))
//         )}
//       </Box>

//       {/* Day View Drawer */}
//       <SwipeableDrawer
//         anchor="right"
//         open={dayDrawerOpen}
//         onClose={handleCloseDayDrawer}
//         PaperProps={{
//           sx: {
//             width: "25vw",
//             maxWidth: "600px",
//           },
//         }}
//       >
//         <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
//           <Box sx={{ p: 2, borderBottom: "1px solid #eee" }}>
//             <Box
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//             >
//               <IconButton onClick={handleCloseDayDrawer}>
//                 <ArrowBackIosRoundedIcon />
//               </IconButton>
//               <Typography variant="h6">
//                 {date.format("MMMM D, YYYY")} - Events
//               </Typography>
//             </Box>
//           </Box>
//           <Box sx={{ flex: 1, overflow: "auto" }}>
//             <DayViewTimeGrid events={selectedDateEvents} date={date} />
//           </Box>
//         </Box>
//       </SwipeableDrawer>

//       {/* Delete Confirmation Dialog */}
//       <DeleteConfirmationDialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//         onConfirm={handleConfirmDelete}
//       />

//       {/* Schedule Event Drawer */}
//       <ScheduleEvent
//         open={scheduleDrawerOpen}
//         onClose={() => {
//           setScheduleDrawerOpen(false);
//           setEditMode(false);
//           setSelectedEvent(null);

//           // Refresh calendar data when closing schedule drawer
//           if (companyName) {
//             const firstDayOfMonth = date.startOf("month");
//             const lastDayOfMonth = date.endOf("month");

//             dispatch(
//               getCompanyEvents({
//                 companyName: companyName,
//                 type: "all",
//                 timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
//                 timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
//               })
//             );
//           }
//         }}
//         selectedEvent={editMode ? selectedEvent : null}
//         selectedDate={date}
//         // Pass the validation function to ScheduleEvent to prevent scheduling in the past
//         validateDateTime={isDateTimeInPast}
//       />
//     </Box>
//   );
// };

// export default CompanyCalender;


import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  Modal,
  Button,
  TextField,
  Select,
  MenuItem,
  Badge,
  Drawer,
  SwipeableDrawer,
  Popover,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getComapnyCalender } from "../../../../Redux/Reducers/JobReducer";
import {
  LocalizationProvider,
  DateCalendar,
  PickersDay,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { Global } from "@emotion/react";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ScheduleEvent from "../SheduleEvent";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import "../../../../Assets/css/Jobs/ScheduleEvent.css";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import {
  deleteProfessionalEvents,
  getCompanyEvents,
  getProfessionalEvents,
} from "../../../../Redux/Reducers/calendarReducer";

const timeZones = Intl.supportedValuesOf("timeZone");

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Event"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this event? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// DayViewTimeGrid is defined OUTSIDE CompanyCalender to prevent it from being
// recreated on every parent render, which was causing first-click state loss.
const DayViewTimeGrid = ({
  events,
  date,
  drawerOpen,
  selectedTimeSlot,
  onEventClick,
  onCloseDrawer,
  onAddNewEvent,
  isDateInPast,
  getEventColor,
  isEventCreator,
  handleEditEvent,
  handleDeleteEvent,
  handleLocationClick,
  handleMeetLinkClick,
}) => {
  const isTodayOrFuture = !isDateInPast(date);
  console.log("selectedTimeSlotsckns", selectedTimeSlot)
  const getTimeSlots = () => {
    const slots = [];
    for (let i = 0; i < 24; i++) {
      slots.push(dayjs().hour(i).minute(0));
    }
    return slots;
  };

  const timeSlots = getTimeSlots();

  const ExpandableText = ({ text, maxLines = 3 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [needsTruncation, setNeedsTruncation] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
      if (textRef.current) {
        const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight);
        const maxHeight = lineHeight * maxLines;
        setNeedsTruncation(textRef.current.scrollHeight > maxHeight);
      }
    }, [text, maxLines]);

    if (!text) return null;

    return (
      <Box>
        <Typography
          ref={textRef}
          variant="body1"
          sx={{
            whiteSpace: "pre-wrap",
            lineHeight: 1.5,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: isExpanded ? "none" : maxLines,
            WebkitBoxOrient: "vertical",
            lineClamp: isExpanded ? "none" : maxLines,
          }}
        >
          {text}
        </Typography>
        {needsTruncation && (
          <Button
            size="small"
            onClick={() => setIsExpanded(!isExpanded)}
            sx={{
              mt: 1,
              textTransform: "none",
              minWidth: "auto",
              padding: "2px 8px",
              fontSize: "0.75rem",
            }}
            color="primary"
          >
            {isExpanded ? "Show Less" : "Show More"}
          </Button>
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ height: "100%", overflow: "auto", backgroundColor: "#fff" }}>
      {/* Today header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid #eee",
        }}
      >
        <Button variant="outlined" startIcon={<TodayRoundedIcon />}>
          {date.format("MMMM D, YYYY")}
        </Button>
        {/* Only show add button for today or future dates */}
        {isTodayOrFuture && (
          <IconButton onClick={onAddNewEvent}>
            <AddCircleOutlineRoundedIcon color="primary" />
          </IconButton>
        )}
      </Box>

      {/* Time slots grid */}
      {timeSlots.map((slot) => {
        const slotEvents =
          events?.filter(
            (event) => dayjs(event.startTime).hour() === slot.hour()
          ) || [];

        return (
          <Box
            key={slot.format("HH:mm")}
            sx={{
              display: "flex",
              borderBottom: "1px solid #eee",
              minHeight: "60px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "60px",
                p: 1,
                color: "text.secondary",
                fontSize: "12px",
                textAlign: "right",
              }}
            >
              {slot.format("h A")}
            </Box>
            <Box
              sx={{
                flex: 1,
                position: "relative",
                borderLeft: "1px solid #eee",
              }}
            >
              {slotEvents.map((event, index) => {
                const startTime = dayjs(event.startTime);
                const endTime = dayjs(event.endTime);

                const startMinutes =
                  startTime.hour() * 60 + startTime.minute();
                const endMinutes = endTime.hour() * 60 + endTime.minute();
                const duration = endMinutes - startMinutes;

                const topPosition = (startMinutes / 1440) * 100;
                const height = (duration / 1440) * 100;

                return (
                  <Card
                    key={`${event.id}-${index}`}
                    onClick={() => onEventClick(event)}
                    sx={{
                      position: "absolute",
                      left: "2px",
                      right: "2px",
                      top: `${topPosition}%`,
                      height: `${height}%`,
                      minHeight: "48px",
                      p: 0.5,
                      backgroundColor: getEventColor(event),
                      cursor: "pointer",
                      "&:hover": {
                        boxShadow: 2,
                        zIndex: 2,
                        transform: "scale(1.02)",
                        transition: "all 0.2s ease",
                      },
                      zIndex: 1,
                      overflow: "hidden",
                      border:
                        event.eventType === "Others"
                          ? "1px solid #80deea"
                          : "1px solid #90caf9",
                    }}
                  >
                    <Box sx={{ width: "100%", height: "100%" }}>
                      <Typography
                        variant="caption"
                        display="block"
                        noWrap
                        sx={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        {event.title}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "8px" }}
                        >
                          {startTime.format("h:mm A")} -{" "}
                          {endTime.format("h:mm A")}
                        </Typography>
                        <Typography
                          color="text.secondary"
                          sx={{ fontSize: "8px" }}
                          noWrap
                        >
                          {event?.interviewType ||
                            event?.eventType ||
                            "Interview"}
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                );
              })}
            </Box>
          </Box>
        );
      })}

      {/* Event Details Drawer */}
      <SwipeableDrawer
        anchor="right"
        open={drawerOpen}
        onClose={onCloseDrawer}
        onOpen={() => { }}
        disableSwipeToOpen
        PaperProps={{
          sx: {
            width: "400px",
            maxWidth: "90vw",
            backgroundColor: "#fff",
            boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
          },
        }}
      >
        <Box sx={{ p: 3, height: "100%", overflow: "auto" }}>
          {selectedTimeSlot && (
            <>
              {/* Header */}
              <Box
                sx={{
                  mb: 3,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pb: 2,
                  borderBottom: "1px solid #eee",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#1a1a1a",
                      textTransform: "capitalize"
                    }}
                  >
                    {selectedTimeSlot?.eventType === "Others" ? "Event Details" : "Interview"}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {isEventCreator(selectedTimeSlot) && (
                    <>
                      <IconButton
                        onClick={() => handleEditEvent(selectedTimeSlot)}
                        color="primary"
                        size="small"
                      >
                        <EditRoundedIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => handleDeleteEvent(selectedTimeSlot?.id)}
                        color="primary"
                        size="small"
                      >
                        <DeleteRoundedIcon />
                      </IconButton>
                    </>
                  )}
                  <IconButton onClick={onCloseDrawer}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* Title */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#f8f9fa",
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    Title
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    {selectedTimeSlot?.title}
                  </Typography>
                </Box>
              </Box>

              {/* Description */}
              {selectedTimeSlot?.description && (
                <Box sx={{ mb: 3, backgroundColor: "#f8f9fa", p: 2, borderRadius: 2 }}>
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    Description
                  </Typography>
                  <ExpandableText
                    text={selectedTimeSlot?.description}
                    maxLength={20}
                  />
                </Box>
              )}

              {/* Time & Duration */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#f8f9fa",
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Box>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Date & Time
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {dayjs(selectedTimeSlot?.startTime).format(
                        "DD MMM YYYY, hh:mm A"
                      )}{" "}
                      - {dayjs(selectedTimeSlot?.endTime).format("hh:mm A")}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                </Box>
              </Box>

              {/* Interview Type */}
              {selectedTimeSlot?.eventType === "Interview" &&
                selectedTimeSlot?.interviewType && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Interview Type
                    </Typography>
                    <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
                      <Typography variant="body1">
                        {selectedTimeSlot?.interviewType}
                      </Typography>
                    </Paper>
                  </Box>
                )}

              {/* Location for F2F or Others */}
              {(selectedTimeSlot?.interviewType === "F2F" || selectedTimeSlot?.meetingType === "Others") &&
                selectedTimeSlot?.location && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Location
                    </Typography>
                    <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
                      <Button
                        variant="text"
                        onClick={() =>
                          handleLocationClick(selectedTimeSlot?.location)
                        }
                        startIcon={<LocationOnRoundedIcon />}
                        sx={{ textTransform: "none" }}
                      >
                        {selectedTimeSlot?.location}
                      </Button>
                    </Paper>
                  </Box>
                )}

              {/* Meet Link for Remote */}
              {(selectedTimeSlot?.interviewType == "Remote" || selectedTimeSlot?.meetingType == "Remote" )&&
                selectedTimeSlot?.meetLink && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Meeting Link
                    </Typography>
                    <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
                      <Button
                        variant="text"
                        onClick={() =>
                          handleMeetLinkClick(selectedTimeSlot?.meetLink)
                        }
                        startIcon={<VideocamRoundedIcon />}
                        sx={{ textTransform: "none" }}
                      >
                        Join Virtual Meeting
                      </Button>
                    </Paper>
                  </Box>
                )}

              {/* Fallback meet_link */}
              {!selectedTimeSlot?.interviewType &&
                selectedTimeSlot?.meet_link && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Meeting Link
                    </Typography>
                    <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
                      <Button
                        variant="text"
                        onClick={() =>
                          handleMeetLinkClick(selectedTimeSlot?.meet_link)
                        }
                        startIcon={<VideocamRoundedIcon />}
                        sx={{ textTransform: "none" }}
                      >
                        Join Virtual Meeting
                      </Button>
                    </Paper>
                  </Box>
                )}

              {/* Attendees */}
              {selectedTimeSlot?.attendees &&
                selectedTimeSlot?.attendees?.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Attendees
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {selectedTimeSlot?.attendees?.map((attendee, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1,
                            backgroundColor: "#f8f9fa",
                            borderRadius: 2,
                          }}
                        >
                          <Avatar
                            src={
                              attendee?.profile_pic ||
                              "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
                            }
                            sx={{ width: 32, height: 32, mr: 1 }}
                          />
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {attendee?.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {attendee?.email}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}

              {/* Created By Information */}
              {selectedTimeSlot?.createdBy && (
                <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #eee" }}>
                  <Typography variant="body2" color="text.secondary">
                    Created by: {selectedTimeSlot?.createdBy}
                  </Typography>
                  {isEventCreator(selectedTimeSlot) && (
                    <Typography variant="caption" color="primary">
                      (You created this event)
                    </Typography>
                  )}
                </Box>
              )}
            </>
          )}
        </Box>
      </SwipeableDrawer>
    </Box>
  );
};

const CompanyCalender = ({ initialView = "month", companyName }) => {
  const dispatch = useDispatch();
  const companyCalender =
    useSelector((state) => state?.calender?.companyEventsData) || [];
  const userEmail =
    useSelector(
      (state) => state?.ProfileArray?.professionaProfile?.professional_email
    ) || "";

  const [date, setDate] = useState(dayjs());
  const [view, setView] = useState(initialView);
  const [selectedDateEvents, setSelectedDateEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [dayDrawerOpen, setDayDrawerOpen] = useState(false);
  const [scheduleDrawerOpen, setScheduleDrawerOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  // Lifted state from DayViewTimeGrid
  const [eventDetailDrawerOpen, setEventDetailDrawerOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

  // Helper function to check if a date is in the past
  const isDateInPast = (dateToCheck) => {
    return dayjs(dateToCheck).isBefore(dayjs(), 'day');
  };

  // Helper function to check if a date/time is in the past
  const isDateTimeInPast = (dateTime) => {
    return dayjs(dateTime).isBefore(dayjs());
  };

  // Filter only interview events
  const interviewEvents = companyCalender.filter(
    (event) =>
      event.eventType === "Interview" ||
      event.eventType === "Others" ||
      event.interviewType
  );

  // console.log("interviewEvents123", interviewEvents, companyCalender);

  useEffect(() => {
    if (view === "month" && companyName) {
      const firstDayOfMonth = date.startOf("month");
      const lastDayOfMonth = date.endOf("month");

      dispatch(
        getCompanyEvents({
          companyName: companyName,
          type: "all",
          timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
          timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
        })
      );
    }
  }, [date, view, companyName, dispatch]);

  // Check if current user is the creator of the event
  const isEventCreator = (event) => {
    return event.createdBy === userEmail;
  };

  const handleDateClick = (newValue) => {
    setDate(newValue);
    const selectedDayStr = newValue.format("YYYY-MM-DD");

    // Filter only interview events for the selected day
    const dayInterviews = interviewEvents?.filter(
      (event) => dayjs(event.startTime).format("YYYY-MM-DD") === selectedDayStr
    );

    setSelectedDateEvents(dayInterviews);
    setDayDrawerOpen(true);
  };

  const handleAddNewEvent = useCallback(() => {
    setEditMode(false);
    setSelectedEvent(null);
    setScheduleDrawerOpen(true);
  }, []);

  const handleEditEvent = (event) => {
    setEditMode(true);
    setSelectedEvent(event);
    setScheduleDrawerOpen(true);
  };

  const handleDeleteEvent = (eventId) => {
    setSelectedEventId(eventId);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await dispatch(deleteProfessionalEvents(selectedEventId));
      setDeleteDialogOpen(false);

      // Refresh calendar data
      if (companyName) {
        const firstDayOfMonth = date.startOf("month");
        const lastDayOfMonth = date.endOf("month");

        dispatch(
          getCompanyEvents({
            companyName: companyName,
            type: "all",
            timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
            timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
          })
        );
      }
    } catch (error) {
      console.error("Failed to delete event:", error);
    }
  };

  const getEventColor = (event) => {
    // Check if event object is provided
    if (!event) {
      return "#e3f2fd"; // Default light blue for calendar days with any events
    }

    if (event.eventType === "Others") {
      return "#e0f7fa"; // Light cyan for "Others" event type
    }

    return "#e3f2fd"; // Light blue for interviews
  };

  // Function to determine calendar day color based on events
  const getDayBackgroundColor = (dayEvents) => {
    if (!dayEvents || dayEvents.length === 0) {
      return 'transparent';
    }

    // Check if any event is "Others" type
    const hasOtherEvents = dayEvents.some(event => event.eventType === "Others");
    // Check if any event is "Interview" type
    const hasInterviewEvents = dayEvents.some(event =>
      event.eventType === "Interview" || event.interviewType
    );

    if (hasOtherEvents && hasInterviewEvents) {
      // Both types present - create gradient
      return 'linear-gradient(135deg, #e3f2fd 50%, #e0f7fa 50%)';
    } else if (hasOtherEvents) {
      // Only "Others" events
      return '#e0f7fa';
    } else {
      // Only interview events or mixed with interviews
      return '#e3f2fd';
    }
  };

  // Function to determine day border color
  const getDayBorderColor = (dayEvents) => {
    if (!dayEvents || dayEvents.length === 0) {
      return 'transparent';
    }

    const hasOtherEvents = dayEvents.some(event => event.eventType === "Others");
    const hasInterviewEvents = dayEvents.some(event =>
      event.eventType === "Interview" || event.interviewType
    );

    if (hasOtherEvents && hasInterviewEvents) {
      return '#1e88e5'; // Darker blue for mixed days
    } else if (hasOtherEvents) {
      return '#00bcd4'; // Cyan border for "Others"
    } else {
      return '#2196f3'; // Blue border for interviews
    }
  };

  // Function to handle location click - opens Google Maps
  const handleLocationClick = (location) => {
    if (location) {
      const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        location
      )}`;
      window.open(mapsUrl, "_blank");
    }
  };

  // Function to handle meet link click - opens in new tab
  const handleMeetLinkClick = (meetLink) => {
    if (meetLink) {
      window.open(meetLink, "_blank");
    }
  };

  // Handlers for the lifted event-detail drawer (was previously local to DayViewTimeGrid)
  const handleEventDetailClick = useCallback((event) => {
    setSelectedTimeSlot(event);
    setSelectedEvent(event);
    setEventDetailDrawerOpen(true);
  }, []);

  const handleCloseEventDetailDrawer = useCallback(() => {
    setEventDetailDrawerOpen(false);
    setSelectedTimeSlot(null);
    setSelectedEvent(null);
  }, []);

  const handleCloseDayDrawer = () => {
    setDayDrawerOpen(false);
    setSelectedDateEvents([]);

    // Refresh calendar data when closing day view
    if (companyName) {
      const firstDayOfMonth = date.startOf("month");
      const lastDayOfMonth = date.endOf("month");

      dispatch(
        getCompanyEvents({
          companyName: companyName,
          type: "all",
          timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
          timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
        })
      );
    }
  };

  const getUniqueEvents = (events) => {
    const map = new Map();
    events.forEach((event) => {
      map.set(event.id, event); // Keeps last unique event
    });
    return Array.from(map.values());
  };

  const todaysInterviews = getUniqueEvents(
    interviewEvents?.filter(
      (event) =>
        dayjs(event?.startTime).format("YYYY-MM-DD") ===
        dayjs().format("YYYY-MM-DD")
    )
  );

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", }}>
      {/* Monthly View */}
      <Card sx={{ p: 2, overflow: "hidden", maxWidth: "100%", margin: "auto" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            value={date}
            onChange={handleDateClick}
            onMonthChange={(newValue) => {
              setDate(newValue);
            }}
            // REMOVED: disablePast={true} - Allow past dates to be visible and clickable
            slots={{
              day: (props) => {
                const { day, ...otherProps } = props;
                const dayStr = day?.format("YYYY-MM-DD");
                const dayInterviews = getUniqueEvents(
                  interviewEvents?.filter(
                    (event) =>
                      dayjs(event?.startTime).format("YYYY-MM-DD") === dayStr
                  )
                );

                // REMOVED: Disabling past days - keep all dates enabled
                return (
                  <PickersDay
                    {...otherProps}
                    day={day}
                    sx={{
                      ...(dayInterviews?.length > 0 && {
                        background: getDayBackgroundColor(dayInterviews),
                        border: `1px solid ${getDayBorderColor(dayInterviews)}`,
                        color: "#1976d2",
                        "&:hover": {
                          backgroundColor: dayInterviews.some(event => event.eventType === "Others")
                            ? "#b2ebf2"
                            : "#bbdefb",
                          opacity: 0.9,
                        },
                        "&.Mui-selected": {
                          background: getDayBackgroundColor(dayInterviews),
                          border: `2px solid ${getDayBorderColor(dayInterviews)}`,
                          "&:hover": {
                            background: getDayBackgroundColor(dayInterviews),
                          },
                        },
                      }),
                    }}
                  />
                );
              },
            }}
          />
        </LocalizationProvider>
      </Card>

      {/* Today's Interviews Section */}
      <Box sx={{ flex: 1, overflow: "auto", px: 2, maxHeight: "50vh", }}>
        <Typography variant="h6" sx={{ p: 1 }}>
          Today's Events
        </Typography>

        {todaysInterviews?.length === 0 ? (
          <Typography variant="body1" color="text.secondary" align="center">
            No events scheduled for today
          </Typography>
        ) : (
          todaysInterviews
            ?.sort((a, b) => dayjs(a?.startTime).diff(dayjs(b?.startTime)))
            ?.map((event) => (
              <Accordion
                key={event?.id}
                sx={{
                  mb: 1,
                  "&:before": { display: "none" },
                  backgroundColor: getEventColor(event),
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: event.eventType === "Others"
                      ? "#b2ebf2"
                      : "#bbdefb",
                  },
                  border: event.eventType === "Others"
                    ? "1px solid #80deea"
                    : "1px solid #90caf9",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreRoundedIcon />}
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      margin: "8px 0",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                        {event?.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {dayjs(event?.startTime).format("h:mm A")} -{" "}
                        {dayjs(event?.endTime).format("h:mm A")}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      {/* Show location icon for F2F */}
                      {event?.interviewType === "F2F" && event?.location && (
                        <LocationOnRoundedIcon
                          fontSize="small"
                          color="primary"
                        />
                      )}
                      {/* Show video icon for Remote */}
                      {event?.interviewType === "Remote" && event?.meetLink && (
                        <VideocamRoundedIcon fontSize="small" color="primary" />
                      )}
                      {/* Fallback for meet_link field */}
                      {!event?.interviewType && event?.meet_link && (
                        <VideocamRoundedIcon fontSize="small" color="primary" />
                      )}
                      <Typography variant="caption" color="text.secondary">
                        {event?.eventType === "Others"
                          ? "Other Event"
                          : event?.interviewType || "Interview"}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    {event?.description && (
                      <Typography variant="body2">
                        {event?.description}
                      </Typography>
                    )}

                    {/* Event Type Display */}
                    {event?.eventType && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          Event Type: {event?.eventType}
                        </Typography>
                      </Box>
                    )}

                    {/* F2F Location */}
                    {event?.interviewType === "F2F" && event?.location && (
                      <Button
                        variant="text"
                        onClick={() => handleLocationClick(event?.location)}
                        startIcon={<LocationOnRoundedIcon />}
                        sx={{ alignSelf: "flex-start", textTransform: "none" }}
                      >
                        {event?.location}
                      </Button>
                    )}

                    {/* Remote Meet Link */}
                    {event?.interviewType === "Remote" && event?.meetLink && (
                      <Button
                        variant="text"
                        onClick={() => handleMeetLinkClick(event?.meetLink)}
                        startIcon={<VideocamRoundedIcon />}
                        sx={{ alignSelf: "flex-start", textTransform: "none" }}
                      >
                        Join Meeting
                      </Button>
                    )}

                    {/* Fallback for meet_link field */}
                    {!event?.interviewType && event?.meet_link && (
                      <Button
                        variant="text"
                        onClick={() => handleMeetLinkClick(event?.meet_link)}
                        startIcon={<VideocamRoundedIcon />}
                        sx={{ alignSelf: "flex-start", textTransform: "none" }}
                      >
                        Join Meeting
                      </Button>
                    )}

                    {event?.attendees?.length > 0 && (
                      <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          Attendees:
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          {event?.attendees?.map((attendee, index) => (
                            <Chip
                              key={index}
                              avatar={
                                <Avatar
                                  src={attendee?.profile_pic}
                                  alt={attendee?.name}
                                />
                              }
                              label={attendee?.name}
                              size="small"
                              variant="outlined"
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    {/* Edit/Delete buttons for creator */}
                    {isEventCreator(event) && (
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          justifyContent: "flex-end",
                          mt: 1,
                        }}
                      >
                        <Button
                          size="small"
                          startIcon={<EditRoundedIcon />}
                          onClick={() => handleEditEvent(event)}
                          color="primary"
                        >
                          Edit
                        </Button>
                        <Button
                          size="small"
                          startIcon={<DeleteRoundedIcon />}
                          onClick={() => handleDeleteEvent(event.id)}
                          color="error"
                        >
                          Delete
                        </Button>
                      </Box>
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
            ))
        )}
      </Box>

      {/* Day View Drawer */}
      <SwipeableDrawer
        anchor="right"
        open={dayDrawerOpen}
        onClose={handleCloseDayDrawer}
        PaperProps={{
          sx: {
            width: "25vw",
            maxWidth: "600px",
          },
        }}
      >
        <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
          <Box sx={{ p: 2, borderBottom: "1px solid #eee" }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <IconButton onClick={handleCloseDayDrawer}>
                <ArrowBackIosRoundedIcon />
              </IconButton>
              <Typography variant="h6">
                {date.format("MMMM D, YYYY")} - Events
              </Typography>
            </Box>
          </Box>
          <Box sx={{ flex: 1, overflow: "auto" }}>
            <DayViewTimeGrid
              events={selectedDateEvents}
              date={date}
              drawerOpen={eventDetailDrawerOpen}
              selectedTimeSlot={selectedTimeSlot}
              onEventClick={handleEventDetailClick}
              onCloseDrawer={handleCloseEventDetailDrawer}
              onAddNewEvent={handleAddNewEvent}
              isDateInPast={isDateInPast}
              getEventColor={getEventColor}
              isEventCreator={isEventCreator}
              handleEditEvent={handleEditEvent}
              handleDeleteEvent={handleDeleteEvent}
              handleLocationClick={handleLocationClick}
              handleMeetLinkClick={handleMeetLinkClick}
            />
          </Box>
        </Box>
      </SwipeableDrawer>

      {/* Delete Confirmation Dialog */}
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {/* Schedule Event Drawer */}
      <ScheduleEvent
        open={scheduleDrawerOpen}
        onClose={() => {
          setScheduleDrawerOpen(false);
          setEditMode(false);
          setSelectedEvent(null);

          // Refresh calendar data when closing schedule drawer
          if (companyName) {
            const firstDayOfMonth = date.startOf("month");
            const lastDayOfMonth = date.endOf("month");

            dispatch(
              getCompanyEvents({
                companyName: companyName,
                type: "all",
                timeMin: firstDayOfMonth.format("YYYY-MM-DD"),
                timeMax: lastDayOfMonth.format("YYYY-MM-DD"),
              })
            );
          }
        }}
        selectedEvent={editMode ? selectedEvent : null}
        selectedDate={date}
        // Pass the validation function to ScheduleEvent to prevent scheduling in the past
        validateDateTime={isDateTimeInPast}
      />
    </Box>
  );
};

export default CompanyCalender;